import React from 'react'
import { Row, Col, Button } from 'reactstrap'
import { withTranslation } from 'react-i18next'
import { processError } from '../../lib/lib'
import api from '../../api/api'
import Cookies from 'universal-cookie'
import PropTypes from 'prop-types'
import { PlayCircle } from "phosphor-react"
import WebinarMiniCard from '../../components/Webinars/WebinarMiniCard.jsx'
import Skeleton from '../../components/UI/Skeleton'
const cookies = new Cookies()

class WebinarDesc extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            webinars: [],
            webinarInfo: {
                title: '',
                desc: '',
                url: '',
                content: '',
            },
            webinarsLoaded: false,
            webinarInfoLoaded: false,
            imageLoaded: false,
            dataLoaded: false,
            // eslint-disable-next-line no-undef
            imageUrl: process.env.REACT_APP_IMAGEURL,
        }
        this.routeToUrl = this.routeToUrl.bind(this)
    }

    routeToUrl() {

    }

    getWebinarInfo(data) {
        return new Promise((resolve, reject) => {
            api.getWebinarInfo(data)
                .then((webinarInfo) => {
                    resolve(webinarInfo)
                })
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    getWebinars(data) {
        return new Promise((resolve, reject) => {
            api.getWebinars(data)
                .then((res) => resolve(res))
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    componentWillMount() {
        const token = cookies.get('accessToken')
        const lang = this.props.i18n.language
        const id = this.props.match.params.webinarId
        let arrPromise = [
            this.getWebinars({ page: 1, limit: 3, lang, token }).then((webinars) => this.setState({ webinarsLoaded: true, webinars })),
            this.getWebinarInfo({ id, lang, token }).then((webinarInfo) => this.setState({ webinarInfoLoaded: true, webinarInfo })),
        ]
        Promise.all(arrPromise).then(() => this.setState({ dataLoaded: true }))
    }

    render() {
        const { t } = this.props
        return (
            <div className="content custom-bg position-relative">
                <div className="page-title">
                    <div className="float-left">
                        <h1 className="title news-dashboard xl-font-size">
                            {t('webinars-theme')} &quot;
                            {
                                this.state.webinarInfoLoaded ?
                                    this.state.webinarInfo.title
                                    : <Skeleton style={{ verticalAlign: 'inherit' }} width={200} />
                            }&quot;
                        </h1>
                    </div>
                </div>
                <Row className="w-100 mx-0 px-15">
                    <Col lg={8} md={12}>
                        {
                            this.state.webinarInfoLoaded ?
                                this.state.webinarInfo.content && <div className="webinar-desc" dangerouslySetInnerHTML={{ __html: this.state.webinarInfo.content }}></div>
                                :
                                <div className="webinar-desc"> <Skeleton count={5} /></div>
                        }
                        {
                            this.state.webinarInfoLoaded ?
                                <div className="webinar-video-wrapper" style={{ backgroundImage: this.state.webinarInfo.image ? `url(${this.state.imageUrl}/${this.state.webinarInfo.image})` : "data:," }}>
                                    <div className="main-logo"></div>
                                    {/* <img src={logo} alt="" className="logo"></img> */}
                                    <a href={this.state.webinarInfo.url} target="_blank" rel="noreferrer" className="link">
                                        <Button type="button" className="btn profile-avatar-btn webinar-btn white" onClick={(event) => this.routeToUrl(event)}>
                                            <PlayCircle size={20} />
                                            <span className="pl-5px sm-font-size"> {t('webinars-watch-webinar')}</span>
                                        </Button>
                                    </a>
                                </div>
                                :
                                <Skeleton height={400} />
                        }
                    </Col>
                    <Col lg={4} md={12}>
                        <div className="webinar-calendar-wrapper">
                            <div className="calendar-title lg-font-size">{t('webinars-calendar')}</div>
                            <div className="calendar-items">
                                {
                                    this.state.webinarsLoaded ?
                                        this.state.webinars.map((webinar) => (
                                            <WebinarMiniCard key={webinar.id}
                                                id={webinar.id}
                                                title={webinar.title}
                                                desc={webinar.desc}
                                                date={webinar.start}
                                                start={webinar.start}
                                                end={webinar.end}
                                                props={this.props}
                                            />
                                        ))
                                        :
                                        <React.Fragment>
                                            <WebinarMiniCard skeleton={true} />
                                            <WebinarMiniCard skeleton={true} />
                                        </React.Fragment>
                                }
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
}

WebinarDesc.propTypes = {
    match: PropTypes.object,
    i18n: PropTypes.object,
    t: PropTypes.func,
    history: PropTypes.object,
}

export default withTranslation()(WebinarDesc)



// WEBPACK FOOTER //
// ./src/views/Webinars/WebinarDesc.jsx